import { z } from "zod";
import { countCharacters } from "@root/shared/utils/countCharacters";

// 「その他」詳細入力のフィールドキー
const OTHER_DETAIL_KEY = "violationTypeOtherDetail";

// 「その他」詳細入力の最大文字数
const OTHER_DETAIL_MAX_LENGTH = 300;

const createMaxLengthValidator = (maxLength: number) => {
  return (value: string | undefined): boolean => {
    if (!value) return true;
    return countCharacters(value) <= maxLength;
  };
};

const createMaxLengthErrorMessage = (maxLength: number): string => {
  return `${maxLength}文字以内で入力してください。`;
};

/**
 * 違反行為の種類選択のバリデーションスキーマ
 */
export const violationTypeSchema = z.object({
  // 違反行為の種類（複数選択可、最低1つ必須）
  violationType: z.array(z.number()).min(1, "1つ以上選択してください。"),
  [OTHER_DETAIL_KEY]: z
    .string()
    .optional()
    .refine(createMaxLengthValidator(OTHER_DETAIL_MAX_LENGTH), {
      message: createMaxLengthErrorMessage(OTHER_DETAIL_MAX_LENGTH),
    }),
});

/**
 * 違反行為の種類選択の型定義
 */
export type ViolationTypeValues = z.infer<typeof violationTypeSchema>;

export { OTHER_DETAIL_KEY, OTHER_DETAIL_MAX_LENGTH };
